import { MuxStreamData } from "types/working-model";
import { GetJson } from "./helpers";

export function GetMuxStreamData(token: string, session_uuid: string, language: string): Promise<MuxStreamData> {
	return GetJson({
		path: `/v4/mux/metrics/${session_uuid}/${language}`,
		token
	});
}